import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { common } from 'src/app/app.common';
import { SaveData } from 'src/app/models/output.model/ResponseLogin';
import { ExportService } from 'src/app/utils/services/export.service';
import { AllService } from 'src/app/Utils/services/all.service';
import { ThongTinNhapHocService } from 'src/app/utils/services/thong-tin-nhap-hoc.service';

@Component({
  selector: 'app-thong-ke-nhap-hoc-sp',
  templateUrl: './thong-ke-nhap-hoc-sp.component.html',
  styleUrls: ['./thong-ke-nhap-hoc-sp.component.scss']
})
export class ThongKeNhapHocSPComponent implements OnInit {

  public com: common;
  Token: any;
  dataTable: any = [];
  dataHe: any = [];
  lstChuyenNganh: any = [];
  dataKhoa: any = [];
  dataKhoaHoc: any = [];
  dataKhoaHoc2: any = [];
  Nam_hoc_arr: any = [];
  recordTotal: any = 0;
  dataLop: any = [];
  dataLop2: any = [];
  dataNCV: any = [];
  dataCV: any = [];
  dataCV2: any = [];
  dataMonHoc: any = [];
  dataBoMon: any = [];
  dataLoaiLop: any = [];
  maGV: any;
  filter = new FormGroup({
    Nam_hoc: new FormControl(2023),
    ID_nganh: new FormControl(0),
  });
  lstNamHoc = [2021, 2022, 2023, 2024, 2025];
  public SaveDate: SaveData;
  constructor(
    public exportService: ExportService,
    private modalService: NgbModal,
    private AllService: AllService,
    public router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private thongTinNhapHocService: ThongTinNhapHocService
  ) {
  }

  ngOnInit(): void {
    this.submit();
    this.getList();
  }

  getList() {
    this.spinner.show();
    this.AllService.getNganh().subscribe((z) => {
      this.lstChuyenNganh = z;
      this.spinner.hide();
    });
  }

  changeHe() {
    if (this.filter.value.ID_he != 0) {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(
        (i) => i.ID_he == this.filter.value.ID_he
      );
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    } else {
      this.dataKhoaHoc2 = this.dataKhoaHoc;
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    }
  }
  changeKhoa() {
    if (this.filter.value.ID_he != 0) {
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc.filter(
          (i) => i.ID_he == this.filter.value.ID_he
        );
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      } else {
        this.dataKhoaHoc2 = this.dataKhoaHoc.filter(
          (i) => i.ID_he == this.filter.value.ID_he
        );
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    } else {
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc;
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      } else {
        this.dataKhoaHoc2 = this.dataKhoaHoc;
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    }
  }

  changeNhomCongViec() {
    if (this.filter.value.iD_nhom_cong_viec != '') {
      this.dataCV2 = this.dataCV.filter(
        (i) => i.ID_nhom_cong_viec == this.filter.value.iD_nhom_cong_viec
      );
      this.dataCV2 = this.dataCV2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.ID_cong_viec === item.ID_cong_viec) === i
      );
    } else this.dataCV2 = this.dataCV;
  }
  ChiTieu: number = 0;
  TrungTuyen: number = 0;
  Nhap_hoc: number = 0;
  XNNH_CT: number = 0;
  XNNH_TT: number = 0;
  Dang_ky: number = 0;
  Da_thu_phieu_diem: number = 0;
  Tra_giay_bao: number = 0;
  Da_thu_ho_so: number = 0;
  Da_thu_hoc_phi: number = 0;
  Hoan_thanh: number = 0;
  Da_rut_ho_so: number = 0;
  Tong_tien: number = 0;

  caculateSum(array: any = []) {
    this.ChiTieu = 0;
    this.TrungTuyen = 0;
    this.Nhap_hoc = 0;
    this.Dang_ky = 0;
    this.XNNH_CT = 0;
    this.XNNH_TT = 0;
    this.Da_thu_phieu_diem = 0;
    this.Tra_giay_bao = 0;
    this.Da_thu_ho_so = 0;
    this.Da_thu_hoc_phi = 0;
    this.Hoan_thanh = 0;
    this.Da_rut_ho_so = 0;
    this.Tong_tien = 0;
    for (let index = 0; index < array.length; index++) {
      const ele = array[index];
      this.ChiTieu += ele.Chi_tieu_tuyen_sinh;
      this.TrungTuyen += ele.Trung_tuyen;
      this.Nhap_hoc += ele.Xac_nhan_nhap_hoc;
      this.Dang_ky += ele.Dang_ky;
      this.Da_thu_phieu_diem += ele.Da_thu_phieu_diem;
      this.Tra_giay_bao += ele.Da_tra_giay_bao;
      this.Da_thu_ho_so += ele.Da_thu_ho_so;
      this.Da_thu_hoc_phi += ele.Da_thu_hoc_phi;
      this.Hoan_thanh += ele.Da_hoan_thanh;
      this.Da_rut_ho_so += ele.Da_rut_ho_so;
      this.Tong_tien += ele.TongTien;
    }
    this.XNNH_CT = (this.Nhap_hoc / this.ChiTieu) * 100;
    this.XNNH_TT = (this.Nhap_hoc / this.TrungTuyen) * 100;
  }

  submit() {
    
    this.spinner.show();
    this.thongTinNhapHocService.getList(0, this.filter.value.Nam_hoc, this.filter.value.ID_nganh).subscribe((z) => {
      this.spinner.hide();
      if (z.Status == 1) {
        this.dataTable = z.ListData;
        this.caculateSum(z.ListData);
      } else {
        this.toastr.warning(z.Message);
      }
    });
  }

}
